import createDynamicForm from './fieldcreator';

const businessForm = () => {
    createDynamicForm([
        {
            name: 'your_name',
            field: {
                type: 'input',
                field_type: 'text',
            },
            label: 'Your Name *',
            placeholder: 'Tell us your name',
            class: 'form-field-popup',
            required: true,
        },
        {
            column: [
                {
                    name: 'phone_number',
                    field: {
                        type: 'input',
                        field_type: 'text',
                        init: 'phone',
                    },
                    label: 'Your Phone Number',
                    placeholder: 'Optionally, your phone',
                    class: 'form-field-popup',
                    id: 'your-phone-number-area',
                    required: false,
                },
                {
                    name: 'email_address',
                    field: {
                        type: 'input',
                        field_type: 'email',
                    },
                    label: 'Your E-mail *',
                    placeholder: 'A valid e-mail address',
                    class: 'form-field-popup',
                    required: true,
                },
                {
                    name: 'full_phone_number',
                    field: {
                        type: 'input',
                        field_type: 'hidden',
                    },
                },
            ]
        },
        {
            column: [
                {
                    name: 'property_name',
                    field: {
                        type: 'input',
                        field_type: 'text',
                    },
                    label: 'Property Name *',
                    placeholder: 'An inspiring name',
                    class: 'form-field-popup',
                    id: 'your-phone-number-area',
                    required: true,
                },
                {
                    name: 'property_location',
                    field: {
                        type: 'input',
                        field_type: 'text',
                    },
                    label: 'Property Location *',
                    placeholder: 'Country and region',
                    class: 'form-field-popup',
                    required: true,
                },
            ]
        },
        {
            column: [
                {
                    name: 'photo_gallery',
                    field: {
                        type: 'input',
                        field_type: 'url',
                    },
                    label: 'Photo Gallery *',
                    placeholder: 'Dropbox or Google Drive link',
                    class: 'form-field-popup',
                    id: 'your-phone-number-area',
                    required: true,
                },
                {
                    name: 'youtube_video',
                    field: {
                        type: 'input',
                        field_type: 'url',
                    },
                    label: 'Youtube Presentation Video',
                    placeholder: 'If available, insert your presentation video',
                    class: 'form-field-popup',
                    required: true,
                },
            ]
        },
        {
            name: 'interior_features',
            field: {
                type: 'textarea'
            },
            label: 'Interior Features',
            placeholder: 'List the interior features (one per row)',
            class: 'form-field-popup',
            required: false,
        },
        {
            name: 'exterior_features',
            field: {
                type: 'textarea'
            },
            label: 'Outdoor Features',
            placeholder: 'List the outdoor features (one per row)',
            class: 'form-field-popup',
            required: false,
        },
        {
            name: 'included_services',
            field: {
                type: 'textarea'
            },
            label: 'Included Services',
            placeholder: 'List the included services (one per row)',
            class: 'form-field-popup',
            required: false,
        },
        {
            name: 'extra_services',
            field: {
                type: 'textarea'
            },
            label: 'Extra Services',
            placeholder: 'List the extra services (one per row)',
            class: 'form-field-popup',
            required: false,
        },
        {
            name: 'your_message',
            field: {
                type: 'textarea'
            },
            label: 'Extra Informations',
            placeholder: 'Let us know if you got extra information related to your business...',
            class: 'form-field-popup',
            required: false,
        }
    ], '/safeprocess/51fd62d5098ccfd99e2bf4c3733ade74', '#dynamic-business');
}

export default businessForm;